import { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  resetState,
  setIsAuthenticated,
  clearSearchForm,
  getCategories,
  getEtats,
  getGroupesContingent,
  getPaysOrigine,
  setIsDecisionMode,
} from "../../modules/dfd/state/DfdActions";
import { getRoles } from "./FunctionsUtils";

const withTokenValidation = (Component, moduleName) => {
  return (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [alreadyNavigated, setAlreadyNavigated] = useState(false);

    useEffect(() => {
      if (location.pathname.startsWith("/reset-password")) {
        return;
      }

      const roles = getRoles();
      let currentHome = "";

      if (
        roles.some((role) =>
          [
            "ROLE_VUPORTUARIA_MEAD",
            "ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE",
            "ROLE_VUPORTUARIA_ADMIN",
            "ROLE_VUPORTUARIA_OPERADOR",
            "ROLE_VUPORTUARIA_FACTURAS_CLIENTE",
            "ROLE_VUPORTUARIA_FACTURAS_EMISOR",
          ].includes(role),
        )
      ) {
        currentHome = "/home";
      }

      const checkTokenExpiration = async () => {
        const token = localStorage.getItem("token");
        if (token) {
          dispatch(setIsAuthenticated(true));
          const decodedToken = jwtDecode(token);
          const currentTime = Date.now() / 1000;
          if (decodedToken.exp < currentTime) {
            localStorage.removeItem("token");
            localStorage.removeItem("suspend");
            localStorage.removeItem("valide");
            dispatch(setIsAuthenticated(false));
            dispatch(resetState());
            if (!alreadyNavigated) {
              navigate("/");
              setAlreadyNavigated(true);
            }
          } else {
            if (location.pathname === "/") {
              switch (moduleName) {
                case "DFD":
                  dispatch(clearSearchForm());
                  dispatch(getCategories());
                  dispatch(getEtats());
                  dispatch(getGroupesContingent());
                  dispatch(getPaysOrigine());
                  dispatch(setIsDecisionMode(true));
                  navigate("/listDemandes");
                  break;
                default:
                  navigate(currentHome);
              }
            }
          }
        } else {
          navigate("/");
        }
      };

      checkTokenExpiration();
    }, [dispatch, navigate, alreadyNavigated]);

    return <Component {...props} />;
  };
};

export default withTokenValidation;
